<template>
  <div class="xianxia-xingwei-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle" :contentWidth=13>
      <div class="left-content" id="remenluxianTable" >时间：
        <ol class="tabli">
          <li :class="{ current: tableTab == 0 }" @click="tableTab = 0">近一月</li>
          <li :class="{ current: tableTab == 1 }" @click="tableTab = 1">近三月</li>
          <li :class="{ current: tableTab == 2 }" @click="tableTab = 2">近一年</li>
          <li :class="{ current: tableTab == 3 }" @click="tableTab = 3">其他时间</li>
          <li :class="{ current: tableTab == 4}" @click="tableTab = 4">2019-06-20~2019-7-1</li>

        </ol>
      </div>

      <div class="left-content" > 景区：
        <ol class="tabli">
          <li :class="{ current: tableTab == 0 }" @click="tableTab = 0">成都市</li>
          <li :class="{ current: tableTab == 1 }" @click="tableTab = 1">景区1</li>
          <li :class="{ current: tableTab == 2 }" @click="tableTab = 2">景区2</li>
          <li :class="{ current: tableTab == 3 }" @click="tableTab = 3">景区3</li>

        </ol>
      </div>

      <div class="shujulaiyuanbianhuaqushifenxi  single-line">
        <div class="chart-title">数据来源变化趋势分析图</div>
        <div class="chart-content">
          <HomeBottomBar
            id="ShengLiangQushiDuidie"
            :chartData="ShengLiangQushiDuidieData"
            v-if="ShengLiangQushiDuidieData"
          />
        </div>
      </div>
      <div class="tingliushijian single-line">
        <div class="chart-title">各来源情绪对比</div>
        <XingbieNianlin
          height="240px"
          id="gelaiyuanqingxuduibi"
          :chartData="QingxuLaiyuanDuibiData"
          v-if="QingxuLaiyuanDuibiData"
        />
      </div>
      <div class="tingliushijian single-line">
        <div class="chart-title">游客评论IP地址分布</div>
        <SpreadMap
                width="856px"
                height="640px"
           id="youkepinglunIpdizhifenbu"
          :chartData="YoukePinglunIPAddFenbuData"
          v-if="YoukePinglunIPAddFenbuData"
        />

      </div>

      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";

import XingbieNianlin from "@/components/Echarts/JingquKoubei/QingxuDuibi.vue";
import HomeBottomBar from "@/components/Echarts/JingquKoubei/HomeBottomLine.vue";
import SpreadMap from "@/components/Echarts/JingquKoubei/SpreadMap.vue";

export default {
  name: "XianxiaXingweiFenxiDetail",
  components: {
    ChildModal,
    XingbieNianlin,
    HomeBottomBar,
    SpreadMap
  },
  props: {},
  data() {
    return {
      YoukePinglunIPAddFenbuData: null,
      ShengLiangQushiDuidieData: null,
      qingxuDuijiData: null,
      qingxuzhanbiData: null,
      zhengmianqingxuzhanbiData: null,
      fumianqingxuzhanbiData: null,
      QingxuLaiyuanDuibiData: null,
      geyebili_fenlei: 0,
      tingliushijian_fenlei: 1,
      retu_month: 7,
      zhejiang: [
        "杭州",
        "湖州",
        "绍兴",
        "宁波",
        "嘉兴",
        "丽水",
        "台州",
        "温州",
        "金华",
        "衢州",
        "舟山"
      ],
      curCity: "杭州",
      cityCenter: [120.215519, 30.253073],
      zhusuretuData: [
        [120.215519, 30.253073, 50],
        [120.336325, 30.264189, 80],
        [120.464863, 30.258372, 60],
        [120.574215, 30.272895, 60],
        [120.637996, 30.209721, 60],
        [120.601811, 30.252331, 99],
        [120.618449, 30.230813, 60],
        [120.680575, 30.298937, 54],
        [120.650751, 30.251395, 55],
        [120.694373, 30.253859, 40]
      ],
      cityListShow: false,
      curTab: 0,
      tabList: [
        "客流热度",
        "5A",
        "4A",
        "3A及以下",
        "山水",
        "博物馆",
        "海岛",
        "主题公园"
      ],
      curTab2: 2,
      tabList2: [
        "综合",
        "交通",
        "服务",
        "安全",
        "消费",
        "卫生",
        "体验",
        "配套",
        "景观"
      ],
      timeList: ["近一月", "近三月", "近一年", "其他时间"],
      jingquList: ["成都市", "景区1", "景区2", "景区3"],
        tableTab:0,
    };
  },
  mounted() {
    // setTimeout(() => {
    //   this.$refs.pointer2.style.transform = "rotate(90deg)";
    // }, 500);

    // 请求数据来源变化趋势分析图

    fetch(
      "/data/JingquKoubei/ShujuLaiyuanDetail/ShujuLaiyuanBianhuaQushiFenxi.json"
    )
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.ShengLiangQushiDuidieData = json.data;
      });
    // 请求各来源情绪对比
    fetch("/data/JingquKoubei/YoukeQingxuFenxiDetail/GeLaiyuanQingxuDuibi.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.QingxuLaiyuanDuibiData = json.data;
      });

    // 请求各来源情绪对比
    fetch("/data/JingquKoubei/ShujuLaiyuanDetail/YoukePinglunIPAddrFenbu.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
         this.YoukePinglunIPAddFenbuData = json.data;
      });
  },
  methods: {

  }
};
</script>

<style scoped lang="less">
.geyebili {
  padding: 0 1rem;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 0.05rem !important;
  .chart-content {
    ol {
      width: 44%;
    }
    ul {
      margin: 1rem auto 0;
      position: relative;
      .yibiao1 {
        float: left;
      }
      .yibiao3 {
        float: right;
      }
      .yibiao2 {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -20%) scale(1.5);
      }
      li {
        width: 2.28rem;
        height: 2.28rem;
        position: relative;
        .info {
          margin-top: 0.12rem;
          width: 100%;
          text-align: center;
          .bili {
            color: #ff553e;
          }
        }
        .bg {
          width: 2.28rem;
          height: 1.14rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan.png)
            no-repeat;
          background-size: 100% 100%;
        }
        .pointer {
          transition: all 0.4s;
          width: 2.28rem;
          height: 2.28rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan_pointer.png)
            no-repeat;
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          left: 0;
          transform: rotate(0deg);
        }
      }
    }
  }
}

.child-detail {
  .tingliushijian {
    .chart-content {
      ol {
        width: 28%;
        li {
          width: 33.33%;
        }
      }
    }
  }
  .zhusuretu {
    .chart-content {
      height: 270px;
      width: 80%;
      ol {
        width: 100%;
        li {
          width: 8.33%;
        }
      }
    }
    .expand {
      height: 0.3rem;
      position: absolute;
      left: 1.1rem;
      top: 0.1rem;
      > div {
        float: left;
        height: 0.3rem;
        line-height: 0.3rem;
      }
      .local {
        width: 0.3rem;
        background: url(../../assets/youkexianxiaxingweifenxi/local.png);
        background-size: 100% 100%;
      }
      .arrow {
        width: 0.3rem;
        background: url(../../assets/header_menu/arrow.png);
        background-size: 100% 100%;
      }
      .city-list {
        position: absolute;
        left: 0;
        top: 0.3rem;
        width: 100%;
        background: #052148;
        border: 1px solid #00cdff;
        padding: 0.05rem 0;
        box-sizing: border-box;
        li:hover {
          background: #0c3964;
        }
      }
    }
  }
}

.content {
  overflow: hidden;
  width: 100%;
  height: 92.5%;
  box-sizing: border-box;
  .tab {
    width: 9.4rem;
    height: 0.24rem;
    margin: 0 auto 0.26rem;
    li {
      width: 12.5%;
      height: 100%;
      float: left;
      color: #fff;
      /*background: url(../../assets/spot_tab_bg.png);*/
      background-size: 100% 100%;
      cursor: pointer;
    }
    .current {
      /*background: url(../../assets/spot_tab_bg_.png);*/
      background-size: 100% 100%;
    }
  }
}
.header {
  /*.chart-content {*/
  /*height: 270px;*/
  /*width: 80%;*/
  ol {
    width: 100%;
    li {
      width: 8.33%;
    }
  }
  /*}*/
  .expand {
    height: 0.3rem;
    position: absolute;
    left: 1.1rem;
    top: 0.1rem;
    cursor: pointer;
    > div {
      float: left;
      height: 0.3rem;
      line-height: 0.3rem;
    }
    .local {
      width: 0.3rem;
      background: url(../../assets/youkexianxiaxingweifenxi/local.png);
      background-size: 100% 100%;
    }
    .arrow {
      width: 0.3rem;
      background: url(../../assets/header_menu/arrow.png);
      background-size: 100% 100%;
    }
    .city-list {
      position: absolute;
      left: 0;
      top: 0.3rem;
      width: 100%;
      background: #052148;
      border: 1px solid #00cdff;
      padding: 0.05rem 0;
      box-sizing: border-box;
      li:hover {
        background: #0c3964;
      }
    }
  }
}

.line {
  width: 100%;
  height: 3rem;
  margin-bottom: 0.75rem;
  > div {
    width: 50%;
    padding: 0 0.7rem;
    box-sizing: border-box;
    height: 100%;
    float: left;
  }
}
.shujulaiyuanbianhuaqushifenxi .chart-content {
  width: 80% !important;
}

.left-content {
  transition: 0.3s;
  width: 100%;
  height: 84%;
  text-align: left;
  line-height: 0.3rem;
  padding-left: 1.6rem;
  .tabli {
    width: 90%;
    margin: -0.05rem auto 0.1rem;
    display: inline-block;
    vertical-align: text-top;
    > li {
      display: inline-block;
      /*      width: 20%;*/
      margin: 0 0.2rem 0.05rem;
      height: 0.3rem;
      line-height: 0.3rem;
      cursor: pointer;
    }
    .current {
      color: @light-blue;
      border-bottom: 1px solid @light-blue;
      background-image: linear-gradient(
              to top,
              rgba(0, 84, 178, 0.4),
              rgba(34, 84, 178, 0.05)
      );
    }
  }
}
</style>
